<template>
  <tr>
    <td>
      <v-autocomplete
        class="ma-0 pa-0"
        :items="$database.songs.array"
        v-model="formData.song_id"
        item-text="ac"
        item-value="id"
        color="secondary"
        :dense="true"
        :hide-details="true"
        placeholder="Search for Songs by Title"
        :menu-props="{contentClass: 'text-uppercase', 'class': 'mt-0 pt-0'}"/>
    </td>
    <td><v-text-field
          class="ma-0 pa-0 centered-input"
          :hide-details="true"
          :dense="true"
          v-model="formData.start_ms"/>
    </td>
    <td><v-text-field
          class="ma-0 pa-0 centered-input"
          :hide-details="true"
          :dense="true"
          v-model="formData.end_ms"/>
    </td>
    <td class="text-xs-center">
      <v-btn icon :color="saveButtonColor" :class="pulseClass" @click="saveVideoSong()" v-if="!busy">
        <v-icon small>{{saveButtonIcon}}</v-icon>
      </v-btn>
      <v-progress-circular indeterminate v-else class="ma-2" size="16" color="secondary"></v-progress-circular>
    </td>
    <td>
      <v-btn icon color="red--text" class="ma-0 pa-0" :disabled="busy" @click="removeVideoSong()">
        <v-icon small>fa-trash-alt</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>

export default {
  name: 'video-song-edit',
  props: {
    video: Object,
    videoSongs: Array, // allows two-way binding
    videoSong: Object
  },
  data () {
    return {
      formData: {
        song_id: null,
        start_ms: null,
        end_ms: null
      },
      busy: false
    }
  },
  computed: {
    changed () {
      var f = this.formData
      var p = this.videoSong
      return f.song_id !== p.sng || f.start_ms !== p.s || f.end_ms !== p.e
    },
    saveButtonIcon () {
      return this.changed ? 'fa-save' : 'fa-check'
    },
    saveButtonColor () {
      return this.changed ? 'lime--text' : 'grey--text'
    },
    pulseClass () {
      return this.changed ? 'pulse ma-0 pa-0' : 'ma-0 pa-0'
    },
    prefix () {
      return `videos/${this.video.id}/`
    }
  },
  methods: {
    saveVideoSong () {
      if (!this.changed) return
      this.busy = true
      var promise
      if (this.videoSong.id > 0) {
        promise = this.$api.videoSongs.update(this.videoSong.id, this.formData, this.prefix)
      } else {
        promise = this.$api.videoSongs.create(this.formData, this.prefix)
      }
      return promise.then(v => {
        var videoSong = this.videoSong
        videoSong.id = v.id
        videoSong.sng = v.sng
        videoSong.s = v.s
        videoSong.e = v.e
        this.updateFormData()
        this.busy = false
      }).catch(e => {
        console.error(e)
        this.busy = false
      })
    },
    removeVideoSong () {
      var index
      this.busy = true
      if (this.videoSong.id < 0) {
        // remove from array without confirmation
        index = this.videoSongs.indexOf(this.videoSong)
        this.videoSongs.splice(index, 1)
        this.busy = false
        return
      }
      this.busy = true
      this.$api.videoSongs.delete(this.videoSong.id, this.prefix).then(_ => {
        index = this.videoSongs.indexOf(this.videoSong)
        this.videoSongs.splice(index, 1)
        this.busy = false
      }).catch(e => {
        console.error(e)
        this.busy = false
      })
    },
    updateFormData () {
      this.formData.song_id = this.videoSong.sng
      this.formData.start_ms = this.videoSong.s
      this.formData.end_ms = this.videoSong.e
    }
  },
  created () {
    this.updateFormData()
  }
}

</script>

<style>
.centered-input input {
  text-align: center;
}
@keyframes shadow-pulse
{
  0% {
    box-shadow: 0 0 0 0px rgb(205, 220, 57);
  }
  100% {
    box-shadow: 0 0 0 35px rgba(0, 0, 0, 0);
  }
}
.pulse
{
  animation: shadow-pulse 1s infinite;
}
</style>
